// extracted by mini-css-extract-plugin
export default {"fab":"resumeFab_fab__F0kpO","iconWrap":"resumeFab_iconWrap__uedEW","label":"resumeFab_label__NLbIa","hidden":"resumeFab_hidden__D-oH9","visible":"resumeFab_visible__qn681"};